export default __webpack_public_path__ + "static/media/mobileScreen3.ff43499e.png";